import { BigNumber } from '@ethersproject/bignumber';
import { useSingleCallResult } from '../state/multicall/multicall.hooks';
import { useMulticallContract } from './use-contract';

// gets the current timestamp from the blockchain
export function useCurrentBlockTimestamp(): BigNumber | undefined {
  const multicall = useMulticallContract();
  return useSingleCallResult(multicall, 'getCurrentBlockTimestamp')?.result?.[0];
}
